import { COLLECTIONS } from "constants/action-types";
import { SaveAssormentSettingsRequest } from "components/product-collection/market-settings/market-settings.types";
import { IDoorTotals } from "reducers/collection";
import { IAllocationDimension } from "helpers/allocation-dimension";

export interface ICopyProps {
    brandId: string;
    collectionId: string;
    collectionType: string;
    name: string;
    withItems: boolean;
    withPermissions: boolean;
    withDefaultRow: boolean;
    withDoorLabels?: boolean;
    allocationData?: boolean;
    withPODetails?: boolean;
    withTargetData?: boolean;
    planData?: boolean;
    excludedAllocationDimensionValues?: { [allocationDimensionId: string]: string[] };
    allocationDimensionValues?: { [allocationDimensionId: string]: string[] };
    parentId: string;
    merchantId?: string;
    targetMerchantId?: string;
    bagVersion?: number;
    collectionPoiId?: string;
    callback?: (assortmentId: string, error: any) => void;
    collectionAllocationDimensions?: IAllocationDimension[];
}

export const syncCollectionObject = (objectNamespace, objectId) => ({
    payload: {
        objectNamespace,
        objectId,
    },
    type: COLLECTIONS.COLLECTION.OBJECT.SYNC.START,
});

export const addHashtags = (hashtags: string[]) => ({
    payload: { hashtags },
    type: COLLECTIONS.COLLECTION.HASHTAGS.ADD,
});

export const updateCollectionSettings = (payload: SaveAssormentSettingsRequest) => ({
    payload,
    type: COLLECTIONS.COLLECTION.UPDATE_COLLECTION_SETTINGS.START,
});

export interface ICollectionSyncErrorThrowAction {
    type: string;
    payload: Error;
}
export interface ILookupAssortmentErrorsAction {
    type: string;
    payload: { assortmentsData?: Array<{ [key: string]: string }> };
}

export interface IAssortmentErrorAction {
    type: string;
    payload: { errorMessage?: string };
}

export const lookupAssortmentErrors = (
    assortmentsData?: Array<{ [key: string]: string }>,
): ILookupAssortmentErrorsAction => ({
    type: COLLECTIONS.COLLECTION.ERROR.ALLOCATION_LOOK_UP_ERROR,
    payload: {
        assortmentsData,
    },
});

export const setAssortmentError = (errorMessage?: string): IAssortmentErrorAction => ({
    type: COLLECTIONS.COLLECTION.ERROR.ALLOCATION_LOOK_UP_SET_ERROR,
    payload: {
        errorMessage,
    },
});

export const updateCollectionReports = (totals: IDoorTotals) => ({
    payload: { totals },
    type: COLLECTIONS.COLLECTION.REPORTING.UPDATES.START,
});
